(function () {
    'use strict';
    angular.module('app.jira', ['app.giteditor', 'md.data.table']);
})();
